import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface SentTopicListPageProps extends NSARouterMakerResult, NotificationSenderProps { }

function SentTopicListPage(props: SentTopicListPageProps)
{
    return (
        <NotificationSenderLayout
            {...props}
            action={{
                description: "Browse all messages that have been sent to Topics, including delivery status, message content, and timestamps. This list helps trace how messages move from sending applications to Topics."
            }}
            pages={{
                entity: NotificationSenderEntity.SentTopic(props),
                list: {}
            }}
        >
            <></>
        </NotificationSenderLayout>
    );
}

export default SentTopicListPage;